let HeCircleMoveToAction = cc.ActionInterval.extend({
    initWithDuration(duration, deltaPosition, speed, radius) {
        let ret = false
        if (cc.ActionInterval.prototype.initWithDuration.call(this, duration)) {
            this._endPosition = deltaPosition
            this._radius = radius
            this._speed = speed
            ret = true
        }
        return ret
    },

    clone() {
        // no copy constructor
        let a = new HeCircleMoveToAction()
        a.initWithDuration(this._duration, this._endPosition, this._speed, this._radius)
        return a
    },

    startWithTarget(target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target)
        this._origialPos = this._previousPosition = this._startPosition = target.getPosition()
        this._positionDelta = cc.pSub(this._endPosition, this._startPosition)
        this._startDegree = 0
    },

    reverse() {
        return HeCircleMoveToAction.create(this._duration, -this._endPosition, -this._speed, this._radius)
    },

    update(t) {
        //MoveTo::update(t)
        if (this.target) {
            this._startDegree += this._speed
            let d = this._startDegree * 0.01745329252
            let oy = this._radius * Math.sin(d)
            let ox = this._radius * Math.cos(d)

            let currentPos = this._origialPos
            let diff = cc.pSub(currentPos, this._previousPosition)
            this._startPosition = cc.pAdd(this._startPosition, diff)
            var pos= {x:this._positionDelta.x*t,y:this._positionDelta.y*t};

            this._origialPos = cc.pAdd(this._startPosition, pos )

            this._previousPosition = this._origialPos

            this.target.setPosition(cc.pAdd(this._origialPos, cc.p(ox, oy)))
        }
    }
})

HeCircleMoveToAction.create = function (duration, deltaPosition, speed, radius) {
    ret = new HeCircleMoveToAction()
    ret.initWithDuration(duration, deltaPosition, speed, radius)
    return ret
}

HeBezierRotationTo = cc.BezierTo.extend({
    initWithDuration(t, rotaionOffset, c) {
        if (cc.BezierTo.prototype.initWithDuration.call(this, t, c)) {
            this._rotationOffset = rotaionOffset
            return true
        }

        return false
    },

    clone() {
        // no copy constructor
        let a = new HeBezierRotationTo()
        a.initWithDuration(this._duration, this._rotationOffset, this._toConfig)
        return a
    },

    update(time) {
        if (this.target) {
            //CCLOG("start:%2.2f, %2.2f, prev:%2.2f, %2.2f", this._startPosition.x, this._startPosition.y, this._previousPosition.x, this._previousPosition.y)
            let ox = this._previousPosition.x
            let oy = this._previousPosition.y
            cc.BezierTo.prototype.update.call(this, time)
            let ang = -Math.atan2(this._previousPosition.y - oy, this._previousPosition.x - ox) * 180 / Math.PI
            if (ang < 0) {
                ang += 360
            }
            this.target.setRotation(ang + this._rotationOffset)
        }
    },

    reverse() {
        cc.assert(false, "HeBezierRotationTo doesn't support the 'reverse' method")
        return null
    }
})
HeBezierRotationTo.create = function (t, rotaionOffset, c) {
    let bezierTo = new HeBezierRotationTo()
    bezierTo.initWithDuration(t, rotaionOffset, $tableToArray(c))
    return bezierTo
}

exports.HeCircleMoveToAction = HeCircleMoveToAction
exports.HeBezierEaseAction = cc.EaseBezierAction
exports.HeBezierRotationTo = HeBezierRotationTo
